import { FrontierService } from '@api';
import { SyslogEventsFilterInput } from '@api/gql/graphql';
import { useAppQuery } from '@api/query/use-app-query';
import { useQuery } from '@tanstack/react-query';
import { getSyslogEventDocument, getSyslogEventsDocument } from './gql';
import { SystemLogKeys } from './queryKeys';

interface GetSyslogEventsArgs {
  offset: number;
  take: number;
  filter?: SyslogEventsFilterInput;
}

export function useGetSyslogEvents(args: GetSyslogEventsArgs) {
  const fetch = async () => {
    const res = await FrontierService.request(getSyslogEventsDocument, {
      pagination: {
        offset: args.offset,
        take: args.take,
      },
      filter: args.filter,
    });
    return res.syslogEvents;
  };

  return useAppQuery([SystemLogKeys.getEvents, JSON.stringify(args)], fetch, {
    keepPreviousData: true,
  });
}

export function useGetSyslogEvent(id: string) {
  return useQuery({
    queryKey: SystemLogKeys.syslogEvent(id),
    queryFn: async () => {
      const res = await FrontierService.request(getSyslogEventDocument, { id });
      return res.syslogEvent;
    },
    enabled: !!id,
  });
}
